/* eslint-disable prettier/prettier */
/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect, useState } from 'react';
import { useTheme } from '../../../providers/theme';
import { Col, Row, Card, Button, Image, Modal } from 'react-bootstrap';
import { toast } from 'react-hot-toast';

import {
  HeroSection,
  EditProfileModal,
  Header,
  FormComp,
  FormCompp,
  DocRejectedForm,
} from '../components';
import {
  useSMupdateProfile,
  useSMMyProfilePage,
  useSMupdateDocRejectProfile,
  useSMroeCompanySetupPage,
  useSMroeCompanySubmitPage,
  useSMGetParishAndCityGetContent,
  useSMReinviteDirector,
} from '../machines';
import { vappContainer, VApplication } from '../../../application';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { OrganisationProfilePageService } from '../services';
import { TweetyWidget } from '@/widgets/tweety-widget-react-main';
import { useSMCreateProfile } from '../machines/createProfile';
import { useSMCreateProfileSave } from '../machines/createProfileSave';
import { AppNavigatorService } from '@/AppNavigator';
import { useSMGetFormData } from './../machines/getFormData';
import { useSMGetFormCity } from './../machines/getCityData';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { Loader } from '@/components';
import { RoeFormComp } from '../components/RoeFormComp';
import { Comments } from '../components/comments';
const getSrv = () => {
  return vappContainer.get<OrganisationProfilePageService>(
    OrganisationProfilePageService.displayName
  );
};

const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const [showModal, setShowModal] = useState({
    type: '',
    show: false,
  });
  const [initialData, setInitialData] = useState<any>({});
  const [parish, setParish] = useState('');
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [rejectmodal, setrejectModel] = useState(false);
  const [formDataConfig, setFormDataConfig] = useState(
    getSrv()?.agent.getStaticPageContentSync()
  );
  const [roeFormDataConfig, setRoeFormDataConfig] = useState(
    getSrv()?.agent.getStaticPageContentSync()
  );
  const storageSrv = StorageModule?.getInstance();
  const userProfile = storageSrv.get('myProfile', 'session');
  const role = userProfile?.org?.orgRole;
  const vuid = userProfile?.vuid;

  // console.log("ille",myProfilePageState?.event?.data?.value?.tcc)
  // const formDataConfig = getSrv()?.agent.getFormData();
  const [roe, setRoe] = useState(true);
  const [fontScale, setFontScale] = useState(
    storageSrv.get('fontScale', 'session') ?? 0
  );
  const updateFontScale = (font: any) => {
    setFontScale(font);
    storageSrv.set('fontScale', font, 'session');
  };
  useEffect(() => {
    if (role === 'BUSSINESS_ORG') setRoe(false);
  }, [role]);
  console.log('fff', role, userProfile);
  const [data, setData] = useState(null);
  const { createProfileSend, createProfileState } = useSMCreateProfile({});
  const {
    createProfileSaveMachine,
    createProfileSaveSend,
    createProfileSaveState,
  } = useSMCreateProfileSave({});
  const {
    ReinviteDirectorMachine,
    ReinviteDirectorSend,
    ReinviteDirectorState,
  } = useSMReinviteDirector({});
  const {
    roeCompanySetupPageMachine,
    roeCompanySetupPageSend,
    roeCompanySetupPageState,
  } = useSMroeCompanySetupPage({});
  const {
    getParishAndCityMachine,
    getParishAndCitySend,
    getParishAndCityState,
  } = useSMGetParishAndCityGetContent({});
  const {
    roeCompanySubmitPageMachine,
    roeCompanySubmitPageSend,
    roeCompanySubmitPageState,
  } = useSMroeCompanySubmitPage({});

  // const { formDataMachine, formDataSend, formDataState } = useSMGetFormData({});
  // const { formCityMachine, formCitySend, formCityState } = useSMGetFormCity({});
  const srv = getSrv();
  const [isCreateProfileButton, setIsCreateProfileButton] = useState(true);
  const [whoAmI, setWhoAmI] = useState('');
  const [touched, setTouched] = useState(false);
  const [buttonText, setbuttonText] = useState('');
  const [flag, setFlag] = useState(false);
  const [implicitsave, setImplicitsave] = useState(false);
  const { updateProfileMachine, updateProfileSend, updateProfileState } =
    useSMupdateProfile({});

  const {
    updateDocRejectProfileMachine,
    updateDocRejectProfileSend,
    updateDocRejectProfileState,
  } = useSMupdateDocRejectProfile({});

  const theme = useTheme();
  const appSrv = getAppSrv();
  const [appno, setAppno] = useState('-');
  const { myProfilePageMachine, myProfilePageSend, myProfilePageState } =
    useSMMyProfilePage({});
  console.log(
    'myProfilePageState',
    myProfilePageState?.event?.data?.value?.status !== 'ONBORADED',
    myProfilePageState
  );
  console.log('roeCompanySetupPageState', roeCompanySetupPageState);
  const getWhoamI = async () => {
    const { whoami } = await appSrv.whoAmI();
    if (!whoAmI) setWhoAmI(whoami);
  };
  useEffect(() => {
    getWhoamI();
  }, []);
  React.useEffect(() => {
    console.log(
      'myProfilePageState?.event?.data?.value?.status',
      myProfilePageState
    );
    setAppno(myProfilePageState?.event?.data?.value?.appno);
    if (myProfilePageState?.event?.data?.value?.status === 'ONBORADED') {
      setShowForm(true);
    }
  }, [
    myProfilePageState?.event?.data?.value &&
      myProfilePageState?.event?.data?.value?.status === 'ONBORADED',
  ]);
  const [citydata, setCitydata] = useState<any>({});
  useEffect(() => {
    if (getParishAndCityState?.matches('RENDER_PAGE')) {
      setCitydata(getParishAndCityState?.event?.data?.value?.data);
    }
  }, [getParishAndCityState]);

  const updateIndustryType = async () => {
    const industryType = await getSrv().agent.getIndustryTypeList();
    console.log('inip->', industryType);
    await setInitialData({
      ...initialData,
      industryTypeList: industryType?.data,
    });
  };
  useEffect(() => {
    console.log('initialdataisthere?', initialData);
    if (Object.keys(initialData).length > 0 && !initialData?.industryTypeList) {
      updateIndustryType();
    }
  }, [initialData]);

  const onButtonPress = (key: string) => {
    // if (!showModal) {
    //   setShowModal(true);
    // }
    if (key === 'edit') {
      setShowModal({
        type: 'edit',
        show: true,
      });
    }
    if (key === 'docRejected') {
      setShowModal({
        type: 'docRejected',
        show: true,
      });
    }
  };
  const onButtonClick = (item: any) => {
    console.log(item);
    const emailItem = item.data.find((entry: any) => entry.title === 'email');
    setbuttonText(item?.buttonText);
    // Get the email address
    const email = emailItem?.subTitle ?? null;
    if (email) {
      ReinviteDirectorSend('START', {
        payload: {
          email: email,
          buttonText: item?.buttonText,
        },
      });
    }
  };
  console.log(
    'myProfilePageState?.event?.data?.value ::',
    myProfilePageState?.event?.data?.value?.initialData?.directors
  );

  const isDateExpired = (dateString: any) => {
    const givenDate = new Date(dateString);
    const today = new Date();
    return givenDate < today;
  };

  if (myProfilePageState?.event?.data?.value?.tccExpiry) {
    // Check if tccExpiryDate is older than today
    if (isDateExpired(myProfilePageState?.event?.data?.value?.tccExpiry)) {
      console.log('The tccExpiryDate is expired.');
      // toast.error("TCC is expired, please update in the edit section",{
      //   id:'tccexpired'
      // })
    } else {
      console.log('The tccExpiryDate is not expired.');
      // toast.success("The tccExpiryDate notexpired .",{
      //   id:'notexpired'
      // })
    }
  } else {
    console.log('tccExpiryDate is not defined.');
  }

  const onModalClose = () => {
    if (showModal) {
      setShowModal({
        show: false,
        type: '',
      });
    }
    if (updateModal) {
      setUpdateModal(false);
    }
  };

  const onRefresh = () => {
    myProfilePageSend('TRIGGER_REFRESH', {});
  };
  const formatData = (data: any) => {
    console.log('formatdata-->directors-->data', data);
    const list = [
      'addressLine1',
      'addressLine2',
      'addressLine3',
      'city',
      'country',
      'parish',
      'state',
      'zipcode',
    ];
    let res = {},
      address = {};
    console.log('diro->', data?.directors, data);
    Object.keys(data).map((i) => {
      if (list.includes(i)) {
        address = { ...address, [i]: data[i] };
      } else if (i === 'isAddDirector') {
        res = { ...res, isDirectorExist: data[i] === 'yes' ? true : false };
      } else if (i === 'isAddSubsidiary') {
        res = { ...res, isSubsidiaryExist: data[i] === 'yes' ? true : false };
      } else if (i === 'isAddBranch') {
        res = { ...res, isBranchExist: data[i] === 'yes' ? true : false };
      } else if (i == 'role') {
      } else if (i === 'directors') {
        let dirarr: any = [];
        data[i] &&
          Array.isArray(data[i]) &&
          data[i]?.length > 0 &&
          data[i].map((director: any) => {
            let dir = {};
            console.log('eachdir->', director);
            Object.keys(director).map((ele: any) => {
              console.log('each123', ele === 'isLastNameExist');
              if (ele === 'id') {
              } else if (ele === 'isLastNameExist') {
                dir = { ...dir, [ele]: director[ele] === 'yes' ? true : false };
              } else {
                dir = { ...dir, [ele]: director[ele] };
              }
            });
            dirarr.push(dir);
          });
        res = { ...res, directors: dirarr };
      } else {
        console.log('formatdata-->directors-->false');
        res = { ...res, [i]: data[i] };
      }
    });
    res = { ...res, address, documents: _getDocument(data) };
    //@ts-ignore
    delete res['taxClearanceCertificate'];
    console.log('formatdata-->directors-->res', res);
    return res;
  };

  const onHideClick = () => {
    if (showModal?.show) {
      setShowModal({
        type: '',
        show: false,
      });
    }
  };

  const onUpdateProfile = (data: any) => {
    console.log(`profile data234`, data, data?.isAddDirector === 'no');
    // setData(getSrv()?.agent.getFormData(data)?.sampleData);
    setShowNotificationModal(true);

    if (showModal) {
      setShowModal({
        show: false,
        type: '',
      });
    }

    let deletearr: any = [];
    let deletearrSub: any = [];
    let deletearrBrn: any = [];

    if (data?.isAddDirector === 'no') {
      let initdata = myProfilePageState?.event?.data?.value?.initialData;
      console.log(
        'directors->',
        myProfilePageState?.event?.data?.value?.initialData
      );
      if (data?.directors && Array.isArray(data?.directors)) {
        data?.directors.map((ed: any) => {
          let deleteobj = {};
          deleteobj = { ...ed, operation: 'REMOVE' };
          deletearr.push(deleteobj);
        });
      }
    } else {
      let initdata = myProfilePageState?.event?.data?.value?.initialData;
      console.log(
        'directors->',
        myProfilePageState?.event?.data?.value?.initialData
      );
      if (data?.directors && Array.isArray(data?.directors)) {
        data?.directors.map((ed: any) => {
          let deleteobj: any = {};
          if (ed?.exist) {
            // const initialDirector = initdata?.directors?.find((d: any) => d.id === ed.id);
            // const isUpdated = initialDirector && JSON.stringify(initialDirector) !== JSON.stringify(ed);
            // deleteobj = { ...ed, operation: isUpdated ? 'UPDATE' : undefined };
            deleteobj = { ...ed, operation: 'UPDATE' };
          } else {
            deleteobj = { ...ed, operation: 'ADD' };
          }
          delete deleteobj.exist;
          deletearr.push(deleteobj);
        });
      }
    }

    if (data?.isAddSubsidiary === 'no') {
      let initdata = myProfilePageState?.event?.data?.value?.initialData;
      console.log(
        'subsidiaries->',
        myProfilePageState?.event?.data?.value?.initialData
      );
      if (data?.subsidiaries && Array.isArray(data?.subsidiaries)) {
        data?.subsidiaries.map((ed: any) => {
          let deleteobj = {};
          deleteobj = { ...ed, operation: 'REMOVE' };
          deletearrSub.push(deleteobj);
        });
      }
    } else {
      let initdata = myProfilePageState?.event?.data?.value?.initialData;
      console.log(
        'directors->',
        myProfilePageState?.event?.data?.value?.initialData
      );
      if (data?.subsidiaries && Array.isArray(data?.subsidiaries)) {
        data?.subsidiaries.map((ed: any) => {
          let deleteobj: any = {};
          if (ed?.exist) {
            deleteobj = { ...ed };
          } else {
            deleteobj = { ...ed, operation: 'ADD' };
          }
          delete deleteobj.exist;
          deletearrSub.push(deleteobj);
        });
      }
    }

    if (data?.isAddBranch === 'no') {
      let initdata = myProfilePageState?.event?.data?.value?.initialData;
      console.log(
        'directors->',
        myProfilePageState?.event?.data?.value?.initialData
      );
      if (data?.branches && Array.isArray(data?.branches)) {
        data?.branches.map((ed: any) => {
          let deleteobj = {};
          deleteobj = { ...ed, operation: 'REMOVE' };
          deletearrBrn.push(deleteobj);
        });
      }
    } else {
      let initdata = myProfilePageState?.event?.data?.value?.initialData;
      console.log(
        'branches->',
        myProfilePageState?.event?.data?.value?.initialData
      );
      if (data?.branches && Array.isArray(data?.branches)) {
        data?.branches.map((ed: any) => {
          let deleteobj: any = {};
          if (ed?.exist) {
            deleteobj = { ...ed };
          } else {
            deleteobj = { ...ed, operation: 'ADD' };
          }
          delete deleteobj.exist;
          deletearrBrn.push(deleteobj);
        });
      }
    }

    console.log('delte123', deletearr);
    deletearr &&
      deletearr.forEach((obj: any) => {
        if ('orgRoles' in obj) {
          delete obj.orgRoles;
        }
      });
    try {
      const finalPayload: any = formatData({
        ...data,
        directors: deletearr,
        subsidiaries: deletearrSub,
        branches: deletearrBrn,
      });
      const { addressLine1, addressLine2, city, parish, zipcode } = data;

      // delete Object.assign(finalPayload, {['operatingAddress']: finalPayload['address'] })['address']

      const operatingAddress = {
        addressLine1: finalPayload?.operatingaddressLine1 ?? addressLine1,
        addressLine2: finalPayload?.operatingaddressLine2 ?? addressLine2,
        city: finalPayload?.operatingCity ?? city,
        parish: finalPayload?.operatingParish ?? parish,
        zipcode: finalPayload?.operatingzipcode ?? zipcode,
      };
      finalPayload.operatingAddress = operatingAddress;
      delete finalPayload.operatingaddressLine1;
      delete finalPayload.operatingaddressLine2;
      delete finalPayload.operatingCity;
      delete finalPayload.operatingParish;
      delete finalPayload.operatingzipcode;
      delete finalPayload.address;
      console.log('ASDASD', finalPayload);
      // const transformAddressFields = (arr: any[]) =>
      //   arr.map(
      //     ({
      //       addressLine1,
      //       addressLine2,
      //       city,
      //       country,
      //       parish,
      //       zipcode,
      //       id,
      //       ...rest
      //     }) => ({
      //       ...rest,
      //       address: {
      //         addressLine1: addressLine1 || null,
      //         addressLine2: addressLine2 || null,
      //         city: city || null,
      //         country: country || null,
      //         parish: parish || null,
      //         state: null,
      //         zipcode: zipcode || null,
      //       },
      //     })
      //   );

      // const transformFinalPayload = (payload: any) => ({
      //   ...payload,
      //   subsidiaries: transformAddressFields(payload.subsidiaries || []),
      //   branches: transformAddressFields(payload.branches || []),
      // });

      const transformAddressFields = (
        arr: any[],
        isSubsidiary: boolean = false
      ) =>
        arr.map(
          ({
            addressLine1,
            addressLine2,
            city,
            country,
            parish,
            zipcode,
            id,
            ...rest
          }) => ({
            ...rest,
            ...(isSubsidiary && { isSubsidiary: true }), // Add isSubsidiary: true only for subsidiaries
            address: {
              addressLine1: addressLine1 || null,
              addressLine2: addressLine2 || null,
              city: city || null,
              country: country || null,
              parish: parish || null,
              state: null,
              zipcode: zipcode || null,
            },
          })
        );

      const transformFinalPayload = (payload: any) => ({
        ...payload,
        subsidiaries: transformAddressFields(payload.subsidiaries || [], true), // Pass true to indicate subsidiaries
        branches: transformAddressFields(payload.branches || []), // Default isSubsidiary to false for branches
      });

      // Example usage
      const transformedPayload = transformFinalPayload(finalPayload);
      console.log(transformedPayload);

      const updatedFinalPayload = transformFinalPayload(finalPayload);
      updateProfileSend('START', {
        payload: {
          ...updatedFinalPayload,
          submit: true,
        },
      });
    } catch (err: any) {
      console.log(err);
    }
  };
  const onDocRejectBtnSubmit = (data: any) => {
    setShowModal({
      type: '',
      show: false,
    });
    updateDocRejectProfileSend('START', {
      payload: {
        documents: data,
        type: 'BUSINESS_ORG',
      },
    });

    console.log('docRejectData :: ', data);
  };
  const onRoeDocRejectBtnSubmit = (data: any) => {
    setShowModal({
      show: false,
      type: '',
    });
    console.log('asdvasfd', data);
    updateDocRejectProfileSend('START', {
      payload: {
        documents: data,
        type: 'CARICOM_BUSINESS_ORG',
        appno: appno ?? '-',
      },
    });
    console.log('docRejectData :: ', data);
  };

  console.log('formDataConfig?', initialData);
  const _renderModal = () => {
    console.log('asdfj,basdvkjdsf', myProfilePageState?.event?.data?.value);
    if (rejectmodal) {
      return (
        <Comments
          comment={myProfilePageState?.event?.data?.value?.comment}
          show={setrejectModel}
          handleClose={() => setrejectModel(false)}
        />
      );
    }
    let modlayout = [
      ['operatingaddressLine1'],
      ['operatingaddressLine2'],
      ['operatingParish', 'operatingCity'],
      ['operatingzipcode'],
      ['isAddDirector'],
      ['isAddSubsidiary'],
      ['isAddBranch'],
      ['primaryContactNo'],
    ];

    // Check if TCC is expired and update modlayout accordingly
    if (isDateExpired(myProfilePageState?.event?.data?.value?.tccExpiry)) {
      modlayout.push(['tccNumber']);
      modlayout.push(['tccExpiryDate']);
      modlayout.push(['taxClearanceCertificate']);
    }

    if (showModal?.show) {
      if (showModal?.type === 'edit') {
        return (
          <EditProfileModal
            // tccExpired={isDateExpired(myProfilePageState?.event?.data?.value?.tccExpiry)}
            showModal={showModal?.show}
            initialData={myProfilePageState?.event?.data?.value}
            fields={formDataConfig?.formData?.fields}
            newFields={formDataConfig?.formData?.newFields}
            dynamicLayout={formDataConfig?.formData?.dynamicLayout}
            // key={new Date().toString()}
            // parish={parish}
            // citydata={citydata}
            whoami={whoAmI}
            layout={modlayout}
            fileFields={formDataConfig?.formData?.fileFields}
            validatorConfig={formDataConfig?.formData?.validatorConfig}
            onAcknowledgement={onUpdateProfile}
            onDeny={() =>
              setShowModal({
                show: false,
                type: '',
              })
            }
          />
        );
      }
      if (showModal?.type === 'docRejected') {
        if (
          myProfilePageState?.event?.data?.value?.type ===
          'CARICOM_BUSSINESS_ORG'
        ) {
          return (
            <DocRejectedForm
              formConfig={formDataConfig?.roeDocRejectedFormData}
              showModal={showModal?.show}
              onHideClick={onHideClick}
              onSubmit={onRoeDocRejectBtnSubmit}
            />
          );
        }
        return (
          <DocRejectedForm
            formConfig={formDataConfig?.docRejectedFormData}
            showModal={showModal?.show}
            onHideClick={onHideClick}
            onSubmit={onDocRejectBtnSubmit}
          />
        );
      }
    }
  };

  useEffect(() => {
    if (myProfilePageState?.event?.data?.value && !data) {
      setData(myProfilePageState?.event?.data?.value?.intialData);
    }
  }, [myProfilePageState?.event?.data?.value]);
  console.log('lp->', data);

  const _getDocument = (payload: any) => {
    console.log('payyloadd', payload);
    const availDocuments = {
      businessRegistration: 'BUSSINESS_REGISTRATION',
      taxClearanceCertificate: 'TAX_CLEARANCE_CERTIFICATE',
      articleOfIncorporation: 'ARTICAL_OF_INCORPORATION',
      certificateOfIncorporation: 'CERTIFICATE_OF_INCORPORATION',
      annualReturn: 'ANNUAL_RETURN',
      immigrationStatus: 'IMMIGRATION_STATUS',
      certificateOfGoodStading: 'CERTIFICATE_OF_GOOD_STANDING',
      bankStatement: 'BANK_STATMENT',
      existingInvoices: 'EXISTING_INVOICES',
      leaseOrRentalAgreement: 'LEASE_AGREEMENT',
      companyReceipt: 'COMPAY_OFFICE_OF_JAMAICA_RECEIPT',
    };
    let documents: any[] = [];
    let reldocs: any = formDataConfig?.formData?.relatedDocuments;
    Object.entries(availDocuments).forEach((ele) => {
      if (
        payload[ele[0]] &&
        Array.isArray(payload[ele[0]]) &&
        payload[ele[0]].length > 0
      ) {
        const ans = payload[ele[0]]?.[0];
        let relateddocs: any =
          (payload?.type && reldocs?.[payload?.type]) || [];
        console.log('anss', ans, relateddocs, payload?.type, ans?.operation);
        // console.log('anss', availDocuments?.[reldocs?.[payload?.type][0] || 'annualReturn']);
        let res;
        if (relateddocs.includes(ele[1])) {
          res = {
            operation: ans?.operation,
            name: ans?.name,
            type: ele[1],
            src: ans?.base64 ?? ans?.src,
            fileType: ans?.type,
          };
        } else if (ele[0] === 'taxClearanceCertificate') {
          res = {
            operation: 'UPDATE',
            name: ans?.name,
            type: 'TAX_CLEARANCE_CERTIFICATE',
            src: ans?.base64 ?? ans?.src,
            fileType: ans?.type,
          };
        } else {
          res = {
            name: ans?.name,
            type: ele[1],
            src: ans?.base64 ?? ans?.src,
            fileType: ans?.type,
            operation: 'REMOVE',
          };
        }
        if (payload[`expiry${ele[0]}`]) {
          //@ts-ignore
          res = { ...res, expiry: payload[`expiry${ele[0]}`] };
        }
        documents.push(res);
      }
    });
    return documents;
  };

  const onFormSubmit = (payload: any) => {
    console.log('find->nextasirformsubmit', payload);
    let _item: any = {};
    const addbranch = payload.isAddBranch;
    const addDirector = payload.isAddDirector;
    const addSubsidiary = payload.isAddSubsidiary;

    const allDynamicItems1 = ['branches', 'subsidiaries', 'directors'];
    let allDynamicItems: any = [];
    if (addbranch === 'yes') allDynamicItems.push('branches');
    if (addDirector === 'yes') allDynamicItems.push('directors');
    if (addSubsidiary === 'yes') allDynamicItems.push('subsidiaries');

    allDynamicItems.forEach((item: any) => {
      if (payload?.[item]) {
        const tempAns: any[] = [];
        payload?.[item]?.forEach((_ele: any) => {
          let ans: any = {};
          const arr = [
            'addressLine1',
            'addressLine2',
            'city',
            'parish',
            'state',
            'zipcode',
            'country',
          ];
          Object.entries(_ele).forEach((temp) => {
            if (arr.includes(temp[0])) {
              ans['address'] = { ...{}, ...ans['address'], [temp[0]]: temp[1] };
            } else if (temp[0] !== 'id') {
              ans[temp[0]] = temp[1];
            }
          });
          if (item === 'subsidiaries') {
            ans = { ...ans, isSubsidiary: true };
            if (addSubsidiary === 'no') {
              ans = { ...ans, operation: 'REMOVE' };
            }
            delete ans.isLastNameExist;
          }
          if (item === 'branches') {
            if (addbranch === 'no') {
              ans = { ...ans, operation: 'REMOVE' };
            }
            delete ans.isLastNameExist;
          }
          if (item === 'directors') {
            ans = {
              ...ans,
              isLastNameExist: ans?.isLastNameExist === 'yes' ? true : false,
              // primaryContactNo: null,
            };
            if (addDirector === 'no') {
              ans = { ...ans, operation: 'REMOVE' };
            }
            let ans1 = Object.entries(ans);
            ans1 = ans1.filter((item) => item[0] !== 'primaryContactNo');
            ans = Object.fromEntries(ans1);
          }
          tempAns.push(ans);
        });
        _item[item] = tempAns;
      }
    });
    const {
      addressLine1,
      addressLine2,
      telephone,
      name,
      website,
      city,
      parish,
      zipcode,
      country,
      incorporationDate,
      type,
      trn,
      registrationNo,
      primaryContactNo,
      natureOfBusiness,
      operatingaddressLine1,
      operatingaddressLine2,
      operatingCity,
      operatingParish,
      operatingzipcode,
      tradingName,
      isAddressSame,
      landlineContactNo,
      businessRegistrationExpiryDate,
      isAddSubsidiary,
      isAddDirector,
      isAddBranch,
      tccExpiryDate,
      companyEmail,
    } = payload;
    const _res = {
      address: {
        addressLine1,
        addressLine2,
        city,
        parish,
        zipcode,
        country,
      },
      isOperatingAddressSame: isAddressSame == 'yes',
      operatingAddress: {
        addressLine1: operatingaddressLine1,
        addressLine2: operatingaddressLine2,
        city: operatingCity,
        parish: operatingParish,
        zipcode: operatingzipcode,
      },
      incorporationDate,
      name,
      country,
      website,
      type,
      trn,
      tradingName,
      registrationNo,
      primaryContactNo,
      natureOfBusiness: natureOfBusiness,
      telephone,
      email: companyEmail,
      landlineContactNo,
      businessRegistrationExpiryDate,
      isBranchExist: isAddBranch == 'yes' ? true : false,
      isDirectorExist: isAddDirector == 'yes' ? true : false,
      isSubsidiaryExist: isAddSubsidiary == 'yes' ? true : false,
      tccExpiryDate,
    };
    _item?.directors &&
      _item?.directors.forEach((obj: any) => {
        if ('orgRoles' in obj) {
          delete obj.orgRoles;
        }
      });
    let finalPayload = {
      ..._res,
      ..._item,
      documents: _getDocument(payload),
    };
    console.log('finalPayload for submit', finalPayload);
    createProfileSend('START', {
      payload: {
        ...finalPayload,
        submit: true,
      },
    });
    // setData(getSrv()?.agent.getStaticPageContentSync(payload)?.sampleData);
    // setShowNotificationModal(true);
  };

  const onNextSubmit = (payload: any) => {
    console.log('find->nextasirnextsubmit ', payload);
    let _item: any = {};
    // const {isAddBranch,isAddDirector,isAddSubsidiary}=payload;
    const addbranch = payload.isAddBranch;
    const addDirector = payload.isAddDirector;
    const addSubsidiary = payload.isAddSubsidiary;

    console.log('find->next->->->', addbranch, addDirector, addSubsidiary);

    const allDynamicItems = ['branches', 'subsidiaries', 'directors'];
    allDynamicItems.forEach((item) => {
      console.log('formatdata..inside->', item);
      if (payload?.[item]) {
        const tempAns: any[] = [];
        payload?.[item]?.forEach((_ele: any) => {
          let ans: any = {};
          const arr = [
            'addressLine1',
            'addressLine2',
            'city',
            'parish',
            'state',
            'zipcode',
            'country',
          ];
          Object.entries(_ele).forEach((temp) => {
            console.log('find->next>>ele', item, _ele, temp, arr);
            if (arr.includes(temp[0])) {
              // if(item==='subsidiaries')
              ans = {
                ...ans,
                address: { ...ans['address'], [temp[0]]: temp[1] },
              };
              console.log('find->next->temp->', temp[0], temp[1], ans, item);
            } else if (temp[0] !== 'id' && temp[0] !== 'address') {
              // console.log("find->next->temp->varala",temp[0]);
              // ans[temp[0]] = temp[1];
              ans = { ...ans, [temp[0]]: temp[1] };
              console.log('find->next->temp->', temp[0], temp[1], ans, item);
            }
          });
          if (item === 'subsidiaries') {
            ans = { ...ans, isSubsidiary: true };
            if (addSubsidiary === 'no') {
              ans = { ...ans, operation: 'REMOVE' };
            }
            delete ans.isLastNameExist;
          }
          if (item === 'branches') {
            if (addbranch === 'no') {
              ans = { ...ans, operation: 'REMOVE' };
            }
            delete ans.isLastNameExist;
          }
          if (item === 'directors') {
            ans = {
              ...ans,
              isLastNameExist: ans?.isLastNameExist === 'yes' ? true : false,
              // primaryContactNo: null,
            };
            const initdata =
              myProfilePageState?.event?.data?.value?.initialData;
            if (addDirector === 'no') {
              ans = { ...ans, operation: 'REMOVE' };
            } else {
              let isExisting = false;
              if (initdata?.directors?.length > 0) {
                if (_ele.id) {
                  isExisting = initdata.directors.some(
                    (d: any) => d.id === _ele.id
                  );
                } else {
                  isExisting = initdata.directors.some(
                    (d: any) =>
                      (d.email && _ele.email && d.email === _ele.email) ||
                      (d.firstName &&
                        _ele.firstName &&
                        d.lastName &&
                        _ele.lastName &&
                        d.firstName === _ele.firstName &&
                        d.lastName === _ele.lastName)
                  );
                }
              }
              ans = {
                ...ans,
                id:
                  _ele.id ||
                  `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
                operation: isExisting ? 'UPDATE' : 'ADD',
              };
            }
            let ans1 = Object.entries(ans);
            // ans1 = ans1.filter((item) => item[0] !== 'primaryContactNo');
            ans = Object.fromEntries(ans1);
            delete ans.isLastNameExist;
          }

          console.log('ANS2S', ans);
          tempAns.push(ans);
          console.log('lastnamecheck->', tempAns);
        });
        _item[item] = tempAns;
      }
    });
    //updating directors
    if (_item?.directors && myProfilePageState?.event?.data?.value) {
      myProfilePageState.event.data.value.initialData = {
        ...myProfilePageState.event.data.value.initialData,
        directors: _item.directors,
      };
    }

    const {
      addressLine1,
      addressLine2,
      name,
      telephone,
      landlineContactNo,
      website,
      city,
      parish,
      zipcode,
      country,
      incorporationDate,
      type,
      trn,
      registrationNo,
      primaryContactNo,
      natureOfBusiness,
      isAddressSame,
      operatingaddressLine1,
      operatingaddressLine2,
      operatingCity,
      operatingParish,
      operatingzipcode,
      tradingName,
      tccExpiryDate,
      businessRegistrationExpiryDate,
      isAddSubsidiary,
      isAddDirector,
      isAddBranch,
      companyEmail,
    } = payload;
    const _res = {
      address: {
        addressLine1,
        addressLine2,
        city,
        parish,
        zipcode,
        country,
      },
      isOperatingAddressSame: isAddressSame == 'yes',
      operatingAddress: {
        addressLine1: operatingaddressLine1 ?? addressLine1,
        addressLine2: operatingaddressLine2 ?? addressLine2,
        city: operatingCity ?? city,
        parish: operatingParish ?? parish,
        zipcode: operatingzipcode ?? zipcode,
      },
      incorporationDate,
      name,
      country,
      website,
      email: companyEmail,
      type,
      trn,
      registrationNo,
      primaryContactNo,
      natureOfBusiness: natureOfBusiness,
      tccExpiryDate,
      businessRegistrationExpiryDate,
      tradingName,
      telephone,
      landlineContactNo,
      isBranchExist: isAddBranch == 'yes' ? true : false,
      isDirectorExist: isAddDirector == 'yes' ? true : false,
      isSubsidiaryExist: isAddSubsidiary == 'yes' ? true : false,
    };
    console.log('NEXTFINAL', _res, _item);

    _item?.directors &&
      _item?.directors.forEach((obj: any) => {
        if ('orgRoles' in obj) {
          delete obj.orgRoles;
        }
      });
    let finalPayload = {
      ..._res,
      ..._item,
      documents: _getDocument(payload),
    };
    //Removing id field from finalPayload.directors to sync with UserInput schema
    if (finalPayload?.directors && Array.isArray(finalPayload.directors)) {
      finalPayload.directors = finalPayload.directors.map((dir: any) => {
        const { id, ...rest } = dir;
        return rest;
      });
    }
    finalPayload?.directors &&
      finalPayload?.directors.forEach((obj: any) => {
        if ('orgRoles' in obj) {
          delete obj.orgRoles;
        }
      });
    console.log('NEXTFINAL', _res, _item, finalPayload);
    createProfileSaveSend('START', {
      payload: {
        ...finalPayload,
        submit: false,
      },
    });
    // setData(getSrv()?.agent.getStaticPageContentSync(payload)?.sampleData);
    // setShowNotificationModal(true);
  };
  const onDraftSubmit = (payload: any) => {
    console.log('find->nextasirroenext ', payload);
    let applicationNo = payload?.applicationNo;
    let _item: any = {};
    // const {isAddBranch,isAddDirector,isAddSubsidiary}=payload;
    const addbranch = payload.isAddBranch;
    const addDirector = payload.isAddDirector;
    const addSubsidiary = payload.isAddSubsidiary;

    console.log('find->next->->->', addbranch, addDirector, addSubsidiary);

    const allDynamicItems = ['branches', 'subsidiaries', 'directors'];
    allDynamicItems.forEach((item) => {
      console.log('formatdata..inside->', item);
      if (payload?.[item]) {
        const tempAns: any[] = [];
        payload?.[item]?.forEach((_ele: any) => {
          let ans: any = {};
          const arr = [
            'addressLine1',
            'addressLine2',
            'city',
            'parish',
            'state',
            'zipcode',
            'country',
          ];
          Object.entries(_ele).forEach((temp) => {
            console.log('find->next>>ele', item, _ele);
            if (arr.includes(temp[0])) {
              console.log('find->next->temp->', temp[0], ans['address']);
              ans['address'] = { ...{}, ...ans['address'], [temp[0]]: temp[1] };
            } else if (temp[0] !== 'id') {
              ans[temp[0]] = temp[1];
            }
          });
          if (item === 'subsidiaries') {
            ans = { ...ans, isSubsidiary: true };
            if (addSubsidiary === 'no') {
              ans = { ...ans, operation: 'REMOVE' };
            }
            delete ans.isLastNameExist;
          }
          if (item === 'branches') {
            if (addbranch === 'no') {
              ans = { ...ans, operation: 'REMOVE' };
            }
            delete ans.isLastNameExist;
          }
          if (item === 'directors') {
            ans = {
              ...ans,
              isLastNameExist: ans?.isLastNameExist === 'yes' ? true : false,
              // primaryContactNo: null,
            };
            if (addDirector === 'no') {
              ans = { ...ans, operation: 'REMOVE' };
            }
            let ans1 = Object.entries(ans);
            // ans1 = ans1.filter((item) => item[0] !== 'primaryContactNo');
            ans = Object.fromEntries(ans1);
          }

          console.log('ANS2S', ans);
          tempAns.push(ans);
          console.log('lastnamecheck->', tempAns);
        });
        _item[item] = tempAns;
      }
    });
    const {
      lastName,
      firstName,
      middleInitial,
      address1,
      address2,
      city,
      placeOfBirth,
      countryOfBirth,
      telephoneNumber,
      landlineContactNo,
      email,
      sex,
      trn,
      dateOfBirth,
      nationality,
      maritalStatus,
      qualificationName,
      occupationalSkill,
      passportno,
      expiryDate,
      natureOfBusiness,
      operatingaddress1,
      isbusinessregistered,
    } = payload;
    const _res = {
      employerInfo: {
        firstName: firstName ?? undefined,
        middleName: middleInitial ?? undefined,
        lastName: lastName ?? undefined,

        address: {
          addressLine1: address1 ?? undefined,
          addressLine2: address2 ?? undefined,
          // addressLine3: businessStreet ?? undefined,
          city: city ?? undefined,
          // country: businessCountry ?? undefined,
          // parish: businessParish ?? undefined,
          // state: undefined,
          // zipcode: businessPostalCode ?? undefined,
        },
        // country: undefined,
        placeOfBirth: placeOfBirth ?? undefined,
        countryOfBirth: countryOfBirth ?? undefined,
        isBussinessRegistered: isbusinessregistered === 'yes' ? true : false,
        trn: trn,
        // dateOfRegistration: dateOfReg ?? undefined,
        // declaration: {
        //   selected: undefined,
        //   value: undefined,
        // },
        // description: undefined,
        email: email ?? undefined,
        // fax: faxNumber ?? undefined,
        // incorporationDate: undefined,
        // isSubsidiary: undefined,
        // logo: undefined,
        // name: businessName ?? undefined,
        // natureOfBusiness: natureOfBusiness ?? undefined,

        primaryContactNo: telephoneNumber ?? undefined,
        landlineContactNo: landlineContactNo ?? undefined,
        gender: sex ?? undefined,
        dateOfBirth: dateOfBirth ?? undefined,
        nationality: nationality ?? undefined,
        maritalStatus: maritalStatus ?? undefined,
        skills: occupationalSkill ?? undefined,
        passportno: passportno ?? undefined,
        passportexpiryDate: expiryDate ?? undefined,
        natureOfBusiness: natureOfBusiness ?? undefined,
        operatingAddress: {
          addressLine1: operatingaddress1 ?? undefined,
        },
        isbusinessregistered: isbusinessregistered ?? undefined,
      },
      // jobInfo: {
      //   necessaryQualification: qualificationName ?? undefined,
      // },
      applicantInfo: {
        highestQualification: qualificationName ?? undefined,
      },
    };
    let finalPayload = {
      ..._res,
      // ..._item,
      ...payload,
      documents: _getDocument(payload),
    };
    console.log('NEXTFINAL', _res, _item, finalPayload, applicationNo);
    roeCompanySetupPageSend('MUTATE', {
      payload: {
        ...finalPayload,
        implicitSave: true,
        applicant: vuid,
        submit: false,
        ...(applicationNo ? { applicationNo: applicationNo } : {}),
      },
      isdraft: true,
    });
    // setData(getSrv()?.agent.getStaticPageContentSync(payload)?.sampleData);
    // setShowNotificationModal(true);
  };
  const onRoeNextSubmit = (payload: any) => {
    console.log('find->nextasirroenext ', payload);
    let applicationNo = payload?.applicationNo;
    let _item: any = {};
    // const {isAddBranch,isAddDirector,isAddSubsidiary}=payload;
    const addbranch = payload.isAddBranch;
    const addDirector = payload.isAddDirector;
    const addSubsidiary = payload.isAddSubsidiary;

    console.log('find->next->->->', addbranch, addDirector, addSubsidiary);

    const allDynamicItems = ['branches', 'subsidiaries', 'directors'];
    allDynamicItems.forEach((item) => {
      console.log('formatdata..inside->', item);
      if (payload?.[item]) {
        const tempAns: any[] = [];
        payload?.[item]?.forEach((_ele: any) => {
          let ans: any = {};
          const arr = [
            'addressLine1',
            'addressLine2',
            'city',
            'parish',
            'state',
            'zipcode',
            'country',
          ];
          Object.entries(_ele).forEach((temp) => {
            console.log('find->next>>ele', item, _ele);
            if (arr.includes(temp[0])) {
              console.log('find->next->temp->', temp[0], ans['address']);
              ans['address'] = { ...{}, ...ans['address'], [temp[0]]: temp[1] };
            } else if (temp[0] !== 'id') {
              ans[temp[0]] = temp[1];
            }
          });
          if (item === 'subsidiaries') {
            ans = { ...ans, isSubsidiary: true };
            if (addSubsidiary === 'no') {
              ans = { ...ans, operation: 'REMOVE' };
            }
            delete ans.isLastNameExist;
          }
          if (item === 'branches') {
            if (addbranch === 'no') {
              ans = { ...ans, operation: 'REMOVE' };
            }
            delete ans.isLastNameExist;
          }
          if (item === 'directors') {
            ans = {
              ...ans,
              isLastNameExist: ans?.isLastNameExist === 'yes' ? true : false,
              // primaryContactNo: null,
            };
            if (addDirector === 'no') {
              ans = { ...ans, operation: 'REMOVE' };
            }
            let ans1 = Object.entries(ans);
            // ans1 = ans1.filter((item) => item[0] !== 'primaryContactNo');
            ans = Object.fromEntries(ans1);
          }

          console.log('ANS2S', ans);
          tempAns.push(ans);
          console.log('lastnamecheck->', tempAns);
        });
        _item[item] = tempAns;
      }
    });
    const {
      lastName,
      firstName,
      middleInitial,
      address1,
      address2,
      city,
      placeOfBirth,
      countryOfBirth,
      telephoneNumber,
      landlineContactNo,
      email,
      sex,
      trn,
      dateOfBirth,
      nationality,
      maritalStatus,
      qualificationName,
      occupationalSkill,
      passportno,
      expiryDate,
      natureOfBusiness,
      operatingaddress1,
      isbusinessregistered,
    } = payload;
    const _res = {
      employerInfo: {
        firstName: firstName ?? undefined,
        middleName: middleInitial ?? undefined,
        lastName: lastName ?? undefined,

        address: {
          addressLine1: address1 ?? undefined,
          addressLine2: address2 ?? undefined,
          // addressLine3: businessStreet ?? undefined,
          city: city ?? undefined,
          // country: businessCountry ?? undefined,
          // parish: businessParish ?? undefined,
          // state: undefined,
          // zipcode: businessPostalCode ?? undefined,
        },
        // country: undefined,
        placeOfBirth: placeOfBirth ?? undefined,
        countryOfBirth: countryOfBirth ?? undefined,
        isBussinessRegistered: isbusinessregistered === 'yes' ? true : false,
        trn: trn,
        // dateOfRegistration: dateOfReg ?? undefined,
        // declaration: {
        //   selected: undefined,
        //   value: undefined,
        // },
        // description: undefined,
        email: email ?? undefined,
        // fax: faxNumber ?? undefined,
        // incorporationDate: undefined,
        // isSubsidiary: undefined,
        // logo: undefined,
        // name: businessName ?? undefined,
        // natureOfBusiness: natureOfBusiness ?? undefined,

        primaryContactNo: telephoneNumber ?? undefined,
        landlineContactNo: landlineContactNo ?? undefined,
        gender: sex ?? undefined,
        dateOfBirth: dateOfBirth ?? undefined,
        nationality: nationality ?? undefined,
        maritalStatus: maritalStatus ?? undefined,
        skills: occupationalSkill ?? undefined,
        passportno: passportno ?? undefined,
        passportexpiryDate: expiryDate ?? undefined,
        natureOfBusiness: natureOfBusiness ?? undefined,
        operatingAddress: {
          addressLine1: operatingaddress1 ?? undefined,
        },
        isbusinessregistered: isbusinessregistered ?? undefined,
      },
      // jobInfo: {
      //   necessaryQualification: qualificationName ?? undefined,
      // },
      applicantInfo: {
        highestQualification: qualificationName ?? undefined,
      },
    };
    let finalPayload = {
      ..._res,
      // ..._item,
      ...payload,
      documents: _getDocument(payload),
    };
    console.log('NEXTFINAL', _res, _item, finalPayload, applicationNo);
    roeCompanySetupPageSend('MUTATE', {
      payload: {
        ...finalPayload,
        implicitSave: true,
        applicant: vuid,
        submit: false,
        ...(applicationNo ? { applicationNo: applicationNo } : {}),
      },
    });
    // setData(getSrv()?.agent.getStaticPageContentSync(payload)?.sampleData);
    // setShowNotificationModal(true);
  };
  const onRoeSubmit = (payload: any) => {
    let applicationNo = payload?.applicationNo;
    console.log('find->nextasirroesubmit ', payload);
    console.log('roecheckkkk---1', payload);
    let _item: any = {};
    // const {isAddBranch,isAddDirector,isAddSubsidiary}=payload;

    setImplicitsave(true);

    let finalPayload = {
      ...payload,
      // ..._item,
      documents: _getDocument(payload),
    };
    console.log('roecheckkkk---2', _item, finalPayload);
    finalPayload?.directors &&
      finalPayload?.directors.forEach((obj: any) => {
        if ('orgRoles' in obj) {
          delete obj.orgRoles;
        }
      });
    console.log('NEXTFINAL', _item, finalPayload);
    roeCompanySubmitPageSend('MUTATE', {
      payload: {
        ...finalPayload,
        submit: true,
        applicant: vuid,
        ...(applicationNo ? { applicationNo: applicationNo } : {}),
      },
    });
    // setData(getSrv()?.agent.getStaticPageContentSync(payload)?.sampleData);
    // setShowNotificationModal(true);
  };
  const _renderPage = () => {
    if (myProfilePageState?.matches('GET_PAGE_CONTENT')) {
      return <Loader {...(formDataConfig?.loading?.loadingProfile || {})} />;
    }
    if (createProfileState?.matches('CREATE_PROFILE')) {
      return <Loader {...(formDataConfig?.loading?.createProfile || {})} />;
    }
    if (ReinviteDirectorState?.matches('REINVITE_DIRECTOR')) {
      return (
        <Loader
          {...(formDataConfig?.loading?.reinviteDirector || {})}
          titleNormalText={
            buttonText === 'ReInvite' ? 'Reinviting the' : 'Reverting the'
          }
        />
      );
    }
    if (
      implicitsave &&
      roeCompanySubmitPageState?.matches(
        'INITIATE_CREATE_DRAFT_ROE_APPLICATION'
      )
    ) {
      return <Loader {...(formDataConfig?.loading?.createProfile || {})} />;
    }

    console.log('init->', initialData);

    if (showForm) {
      console.log(showForm, roe);
      if (roe) {
        return (
          <RoeFormComp
            fontScale={fontScale}
            updateFontScale={updateFontScale}
            formData={formDataConfig?.roeFormData}
            label={formDataConfig?.roeFormData?.label}
            onAcknowledgement={onRoeSubmit}
            onNextClick={onRoeNextSubmit}
            onDraftClick={onDraftSubmit}
            parish={parish}
            initialData={initialData}
            setInitialData={setInitialData}
            //setParish={setParish}
            setImplicitsave={setImplicitsave}
            onGoBack={() => setShowForm(false)}
            whoami={whoAmI}
            touchedStatus={touched}
            _changeTouchStatus={(val: any) => setTouched({ ...val })}
            rightBlockContent={formDataConfig?.rightBlockContent}
          />
        );
      } else {
        return (
          <>
            <FormCompp
              fontScale={fontScale}
              updateFontScale={updateFontScale}
              formData={formDataConfig?.formData}
              label={formDataConfig?.formData?.label}
              onAcknowledgement={onFormSubmit}
              onNextClick={onNextSubmit}
              parish={parish}
              initialData={initialData}
              setInitialData={setInitialData}
              //setParish={setParish}
              citydata={citydata}
              onGoBack={() => setShowForm(false)}
              whoami={whoAmI}
              touchedStatus={touched}
              _changeTouchStatus={(val: any) => setTouched({ ...val })}
              rightBlockContent={formDataConfig?.rightBlockContent}
            />
          </>
        );
      }
    }
    if (updateProfileState?.matches('UPDATE_PROFILE')) {
      return <Loader {...(formDataConfig?.loading?.updateProfile || {})} />;
    }
    console.log('updateDocRejectProfileState', updateDocRejectProfileState);
    if (updateDocRejectProfileState?.matches('UPDATE_DOC_REJECT_PROFILE')) {
      return <Loader {...(formDataConfig?.loading?.updateProfile || {})} />;
    }

    if (
      myProfilePageState?.matches('RENDER_PAGE') &&
      myProfilePageState?.event?.data?.value
    ) {
      console.log('find->orgprofile', myProfilePageState?.event?.data?.value);
      if (
        myProfilePageState?.event?.data?.value &&
        myProfilePageState?.event?.data?.value?.status !== 'ONBORADED'
      ) {
        console.log('onborad', myProfilePageState?.event?.data?.value);
        return (
          <>
            {isDateExpired(
              myProfilePageState?.event?.data?.value?.tccExpiry
            ) ? (
              <div style={{ color: 'red', textAlign: 'center' }}>
                Your Tax Clearance Certificate (TCC) has expired. Please update
                it by clicking on "edit profile".
              </div>
            ) : null}

            <HeroSection
              // {...data}
              {...(myProfilePageState?.event?.data?.value || {})}
              onHeroButtonClick={onButtonPress}
              onButtonClick={onButtonClick}
              showcomment={rejectmodal}
              statusComp={
                myProfilePageState?.event?.data?.value?.tccExpiry
                  ? isDateExpired(
                      myProfilePageState?.event?.data?.value?.tccExpiry
                    )
                    ? {
                        title: `TCC EXPIRED`,
                        statusType: 'danger',
                      }
                    : myProfilePageState?.event?.data?.value?.statusComp
                  : myProfilePageState?.event?.data?.value?.statusComp
              }
              setShowComment={setrejectModel}
            />
          </>
        );
      }
      return (
        <>
          <Loader {...(formDataConfig?.loading?.usersEmpty || {})} />
        </>
      );
    }
    return null;
  };
  const _renderErrorModals = () => {
    if (myProfilePageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(formDataConfig?.error?.getProfile || {})}
          description={[myProfilePageState?.event?.data?.value]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (ReinviteDirectorState?.matches('REINVITE_DIRECTOR_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(formDataConfig?.error?.reinviteDirector || {})}
          description={[ReinviteDirectorState?.event?.data?.value]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (updateProfileState?.matches('UPDATE_PROFILE_FAILED')) {
      console.log(
        'editprofile errorcheck-->',
        updateProfileState,
        updateProfileState?.event?.data?.value
      );
      return (
        <NotificationModal
          showModal={true}
          {...(formDataConfig?.error?.updateProfile || {})}
          description={[
            updateProfileState?.event?.data?.value,
            // formDataConfig?.error?.updateProfile?.description[1],
          ]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };
  const _renderErrors = () => {
    // if (createProfileState?.matches('CREATE_PROFILE_FAILED')) {
    //   return (
    //     <NotificationModal
    //       showModal={true}
    //       {...(formDataConfig?.error?.createProfile || {})}
    //       onAcknowledgement={onRefresh}
    //       description={[createProfileState?.event?.data?.value]}
    //       onDeny={onRefresh}
    //     />
    //   );
    // }

    if (
      implicitsave &&
      roeCompanySubmitPageState?.matches('CREATE_DRAFT_ROE_APPLICATION_ERROR')
    ) {
      return (
        <NotificationModal
          showModal={true}
          {...(formDataConfig?.error?.createProfile || {})}
          onAcknowledgement={onRefresh}
          description={[roeCompanySubmitPageState?.event?.data?.value]}
          onDeny={onRefresh}
        />
      );
    }

    if (
      updateDocRejectProfileState?.matches('UPDATE_DOC_REJECT_PROFILE_FAILED')
    ) {
      return (
        <NotificationModal
          showModal={true}
          {...(formDataConfig?.error?.createProfile || {})}
          description={[updateDocRejectProfileState?.event?.data?.value]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };
  const _renderNotification = () => {
    if (
      updateDocRejectProfileState?.matches('UPDATE_DOC_REJECT_PROFILE_SUCCESS')
    ) {
      return (
        <NotificationModal
          showModal={true}
          {...(formDataConfig?.notifications?.docUpdateSuccess || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }

    if (updateProfileState?.matches('UPDATE_PROFILE_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(formDataConfig?.notifications?.updateProfileSuccess || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (
      createProfileState?.matches('CREATE_PROFILE_SUCCESS') ||
      (implicitsave &&
        roeCompanySubmitPageState?.matches(
          'CREATE_DRAFT_ROE_APPLICATION_SUCCESS'
        ))
    ) {
      return (
        <NotificationModal
          showModal={true}
          {...(formDataConfig?.notifications?.createProfileSuccess || {})}
          onAcknowledgement={() => {
            window.location.reload();
          }}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const onCreateProfile = () => {
    setShowForm(true);
  };
  const ReiniviteSuccess = () => {
    if (ReinviteDirectorState?.matches('REINVITE_DIRECTOR_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(formDataConfig?.notifications?.reinviteDirector || {})}
          description={
            buttonText === 'ReInvite'
              ? ['Director reinvited successfully.']
              : ['Director reverted successfully.']
          }
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };
  const _renderHeader = () => {
    if (myProfilePageState?.event?.data?.value) {
      console.log(
        '_renderHeader find->',
        myProfilePageState?.event?.data?.value
      );
      return (
        <>
          <Header
            onBackClick={() => setShowForm(false)}
            {...(formDataConfig?.header || {})}
            headerAction1={
              myProfilePageState?.event?.data?.value?.status === 'ONBORADED' &&
              !showForm
                ? formDataConfig?.header?.headerAction1
                : null
            }
            onHeaderAction1Click={onCreateProfile}
          />
        </>
      );
    }
    return null;
  };

  return (
    <>
      {_renderHeader()}
      {_renderPage()}
      {_renderModal()}
      {_renderErrorModals()}
      {_renderNotification()}
      {_renderErrors()}
      {ReiniviteSuccess()}
    </>
  );
};
